import React from "react";
import { MARKETING_MEDIA } from "../../../config/marketing/media";
import VideoPreview from "../../../pages/Marketing/components/VideoPreview";
import { assets } from "../../../assets/assets";

const BookingPageMedia = () => {
    const videoSrc = MARKETING_MEDIA.doctorWebsiteVideo.src;

    return (
        <div className="w-full flex justify-center md:h-[600px]">
            {/* OUTER FRAME — controls layout */}
            <div className="relative w-full bg-surface-gradient-subtle px-6 py-6 lg:py-16">
                {/* INNER SURFACE */}
                <div className="overflow-hidden rounded-2xl bg-bg-page ">
                    <VideoPreview src={videoSrc} poster={assets.website_video_thumbnail} />
                </div>
            </div>
        </div>
    );
};

export default BookingPageMedia;
